<template>
    <section class="home-container">
        <MasterPage title="医生管理">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="医生姓名：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="医生职称：">
                            <Input v-model="select.title" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="医生专长：">
                            <Input v-model="select.profession" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="医生状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增医生" @on-cancel="cancelItem">
            <Form :label-width="90">
                <FormItem label="医生头像：">
                    <Upload
                            ref="uploadImage"
                            multiple
                            type="drag"
                            :format="['jpg','jpeg','png']"
                            accept="image/*"
                            :before-upload="fileBefore"
                            :on-success="fileSuccess"
                            :on-error="fileError"
                            action="food/file/upload">
                        <div :style="{padding:'10px 0',backgroundImage: 'url(\'' + itemAdd.imageUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>单击或拖动图片以上传</p>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem label="医生姓名：">
                    <Input v-model="itemAdd.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="医生职称：">
                    <Input v-model="itemAdd.title" placeholder="请输入" />
                </FormItem>
                <FormItem label="医生专长：">
                    <Input v-model="itemAdd.profession" placeholder="请输入" />
                </FormItem>
                <FormItem label="医生简介：">
                    <Input v-model="itemAdd.introduction" type="textarea" :autosize="{minRows: 3,maxRows: 5}" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改医生" @on-cancel="cancelItem">
            <Form :label-width="90">
                <FormItem label="医生头像：">
                    <Upload
                            ref="uploadImageUpdate"
                            multiple
                            type="drag"
                            :format="['jpg','jpeg','png']"
                            accept="image/*"
                            :before-upload="fileBefore"
                            :on-success="fileSuccess_update"
                            :on-error="fileError"
                            action="food/file/upload">
                        <div :style="{padding:'10px 0',backgroundImage: 'url(\'' + updateInfoItem.imageUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>单击或拖动图片以上传</p>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem label="医生姓名：">
                    <Input v-model="updateInfoItem.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="医生职称：">
                    <Input v-model="updateInfoItem.title" placeholder="请输入" />
                </FormItem>
                <FormItem label="医生专长：">
                    <Input v-model="updateInfoItem.profession" placeholder="请输入" />
                </FormItem>
                <FormItem label="医生简介：">
                    <Input v-model="updateInfoItem.introduction" type="textarea" :autosize="{minRows: 3,maxRows: 5}" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="医生详情">
            <Form :label-width="90">
                <FormItem  label="医生头像：">
                    <img :src="`food/${infoItem.imageUrl}`" style="max-height: 125px;max-width: 100%">
                </FormItem>
                <FormItem  label="医生姓名：">
                    {{infoItem.name}}
                </FormItem>
                <FormItem label="医生职称：">
                    {{infoItem.title}}
                </FormItem>
                <FormItem label="医生专长：">
                    {{infoItem.profession}}
                </FormItem>
                <FormItem label="医生简介：">
                    <div style="white-space:pre-wrap">{{infoItem.introduction}}</div>
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '姓名',
                        key: 'name',
                        tooltip:true,
                        ellipsis: true,
                        align: 'center',
                    },
                    {
                        title: '职称',
                        key: 'title',
                        tooltip:true,
                        ellipsis: true,
                        align: 'center',
                    },
                    {
                        title: '专长',
                        key: 'profession',
                        tooltip:true,
                        ellipsis: true,
                        align: 'center',
                    },
                    {
                        title: '账号',
                        tooltip:true,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.account){
                                return h('span', params.row.account)
                            }else{
                                return h('span', '未绑定')
                            }
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    name:'',
                    title:'',
                    profession:'',
                    isDeleted:'false',
                },
                itemAdd:{
                    imageUrl:'',
                    name:'',
                    title:'',
                    profession:'',
                    introduction:'',
                },
                updateInfoItem:"",
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            fileBefore(file){
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
                if (file.type.substring(0,file.type.indexOf("/")).toLowerCase() != 'image' ) {
                    this.$Message.warning('只能上传图片文件');
                    return false
                }
                if (file.size > 1048576) {
                    this.$Message.warning('图片大小请勿超过1M');
                    return false
                }
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title:'图片上传成功'});
                this.itemAdd.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'图片上传成功'});
                this.updateInfoItem.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileError(error){
                this.$Notice.error({title:'图片上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('doctor/list',{
                    name:this.select.name,
                    title:this.select.title,
                    profession:this.select.profession,
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'医生列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入医生姓名');
                }
                if (this.itemAdd.title.length <= 0){
                    return this.$Message.warning('请输入医生职称');
                }
                if (this.itemAdd.profession.length <= 0){
                    return this.$Message.warning('请输入医生专长');
                }
                this.addLoading = true
                this.$http.post('doctor/add',
                    this.itemAdd,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入医生姓名');
                }
                if (this.updateInfoItem.title.length <= 0){
                    return this.$Message.warning('请输入医生职称');
                }
                if (this.updateInfoItem.profession.length <= 0){
                    return this.$Message.warning('请输入医生专长');
                }
                this.updateLoading = true
                this.$http.post('doctor/update',
                    this.updateInfoItem,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd = {
                    imageUrl:'',
                    name:'',
                    title:'',
                    profession:'',
                    introduction:'',
                },
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用医生“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('doctor/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用医生“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('doctor/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


